module.exports = __webpack_public_path__ + "static/media/Gas.c5e55cec.svg";